import { PowersearchModule } from '@abovo/powersearch';
import { AssetLoaderModule, ImageFallbackModule, ResizeObserverDirective, ScrollbarOverlayModule, WindowRef } from '@abovo/shared-angular-utils';
import { DataLayerService, EmployeeImageModule } from '@abovo/shared-services';
import { ListViewModule, NoContentModule, SharedUiCoreModule } from '@abovo/shared-ui-components';
import { DATA_PROV_SERVICE_PK, coreEffects, coreReducers } from '@abovo/webvis-data-access';
import { FabButtonsComponent, NavListModule, PageHeaderComponent, PageWrapComponent, WebvisUiModule } from '@abovo/webvis-ui';
import { NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { LetDirective } from '@ngrx/component';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { WebvisPageWrapV2Component } from './containers';
import { WebvisGuard } from './guards';

@NgModule({
   imports: [
      WebvisPageWrapV2Component,
      SharedUiCoreModule,
      StoreModule.forFeature('core', coreReducers),
      EffectsModule.forRoot(coreEffects),
      PageWrapComponent,
      WebvisUiModule,
      ScrollToModule.forRoot(),
      RouterModule,
      AssetLoaderModule,
      NavListModule,
      InfiniteScrollDirective,
      ScrollbarOverlayModule,
      NoContentModule,
      ListViewModule,
      PowersearchModule,
      FabButtonsComponent,
      LetDirective,
      MatDialogModule,
      EmployeeImageModule,
      ImageFallbackModule,
      NgOptimizedImage,
      ResizeObserverDirective,
      PageHeaderComponent,
   ],
   providers: [
      WebvisGuard,
      DataLayerService,
      WindowRef,
      {
         // This provides a default value for the CustomDataProvider primary key
         provide: DATA_PROV_SERVICE_PK,
         useValue: 'id',
      },
   ],
})
export class WebvisCoreModule {}
